module.exports = __webpack_public_path__ + "img/10.968dbcf3.jpg";